import axios from 'axios';

const API_BASE = process.env.REACT_APP_API_BASE || 'http://127.0.0.1:8000';

function authHeader() {
  const auth = JSON.parse(localStorage.getItem('zocs_auth') || '{}');
  return { Authorization: `Bearer ${auth.token}` };
}

export async function getPendingRiders() {
  const res = await axios.get(`${API_BASE}/dispatch/rider-admin/pending-riders`, {
    headers: authHeader(),
  });
  return res.data;
}

export async function updateRiderStatus(riderId, status) {
  const res = await axios.post(
    `${API_BASE}/dispatch/rider-admin/riders/${riderId}/status`,
    { status },
    { headers: authHeader() }
  );
  return res.data;
}
